import {
  NativeTopBarStyle,
  dispatchAction,
} from '@omni/kit/utilities/NativeHelpers';

import BlockPage from '../BlockPage';
import { IBlockProps } from './types';
import KitFrame from '@omni/kit/components/KitFrame';
import React from 'react';
import { getSpacing } from '@omni/kit/theming/SpacingType';

export interface FrameBlockProps extends IBlockProps {
  title?: string;
  action?: any;
  enableChevron?: boolean;
  blocks?: [];
}

const FrameBlock = ({
  title,
  action,
  blocks,
  enableChevron,
  topSpacing,
  bottomSpacing,
}: FrameBlockProps): JSX.Element => {
  const _onPress = () => {
    dispatchAction(action);
  };

  const viewStyle = {
    marginTop: getSpacing(topSpacing),
    marginBottom: getSpacing(bottomSpacing),
  };

  return (
    <KitFrame
      title={title}
      enableChevron={enableChevron}
      onPress={action ? _onPress : undefined}
      insetStyle={viewStyle}
    >
      <BlockPage
        data={{ blocks: blocks }}
        theme={'light'}
        /**
         * When nesting a BlockPage in KitFrame, we need to avoid passing a
         * `topBarStyle` value to prevent the child BlockPage from changing
         * the state of top navbar
         */
        topBarStyle={undefined}
      />
    </KitFrame>
  );
};

export default FrameBlock;
